$(function(){
	$('[data-pl-src]').each(function(){
		var src = $(this).attr('data-pl-src');
		// if(src.split('.')[1] == 'mp4'){
		// 	// is video
		// 	var video = $('<video autoplay muted loop>'),
		// 		source = $('<source>');
		// 	source.attr('src',src).appendTo(video);
		// 	$(this).after(video);
		// 	$(this).remove();
		// } else{
			$(this).attr('src',src);
		// }
	});
});